<template>
    <div class="mt-4">
        <!-- <table class="text-left w-full border-collapse shadow-md">
            <tbody>
                <tr class="text-white text-center">
                    <th class="bg-teal border-grey-light px-4 py-1">&nbsp;</th>
                    <th class="bg-teal border-grey-light px-4 py-1">
                        Follow Up
                    </th>
                    <th v-for="sales_behavior in sales_behaviors" :key="sales_behavior.id"
                        class="bg-teal border-grey-light px-4 py-1">
                        {{sales_behavior.name}}
                    </th>
                    <th class="bg-teal border-grey-light px-4 py-1">
                        <button
                            class="text-white focus:outline-none p-2 border-solid border-1 border-white rounded-lg hover:text-teal hover:bg-teal-light"
                            @click.prevent="updatePermissions()">
                            <i class="fa fa-save"></i> Save
                        </button>
                    </th>
                </tr>
                <tr v-for="user in users" :key="user.id" class="text-center  border-b border-grey-light border-grey-light">
                    <td class="px-4 py-4">
                        {{user.name}}
                    </td>
                    <td class="py-4">
                        <input type="checkbox" v-model="user.follow_up">
                    </td>
                    <td v-for="sales_behavior in user.sales_behaviors" :key="sales_behavior.id" class="py-4">
                        <input type="checkbox" v-model="sales_behavior.enabled">
                    </td>
                    <td class="px-4 py-4">&nbsp;</td>
                </tr>
            </tbody>
        </table> -->

        <table class="text-left w-full border-collapse shadow-md">
            <tbody>
                <tr class="text-white text-center">
                    <th class="bg-teal border-grey-light px-4 py-1">
                        Select User
                    </th>
                    <th class="bg-teal border-grey-light px-4 py-1">
                        Sales Activities
                    </th>
                    <th class="bg-teal border-grey-light px-4 py-1">
                        Contact Activities
                    </th>
                    <th v-if="Object.keys(selectedUser).length">
                    </th>
                </tr>
                <tr class="border-b border-grey-light border-grey-light">
                    <td class="px-4 py-4" style="vertical-align:top;">
                        <multiselect
                            :options="users"
                            v-model="selectedUser"
                            :show-labels="false"
                            placeholder="Select User"
                            track-by="id"
                            label="name"
                            class="cursor-pointer"
                            @input="fetchData">
                        </multiselect>
                    </td>
                    <td class="py-4" v-if="Object.keys(selectedUser).length" style="vertical-align:top;">
                        <ul>
                            <li v-for="sales_behavior in selectedUser.sales_behaviors" :key="sales_behavior.id">
                                <label><input type="checkbox" v-model="sales_behavior.enabled">
                                <span>{{sales_behavior.name}}</span></label>
                            </li>
                        </ul>
                    </td>
                    <td class="py-4" v-if="Object.keys(selectedUser).length" style="vertical-align:top;">
                        <ul>
                            <li v-for="sales_behavior in selectedUser.contact_sale_behaviors" :key="sales_behavior.id">
                                <label><input type="checkbox" v-model="sales_behavior.enabled">
                                <span>{{sales_behavior.name}}</span></label>
                            </li>
                        </ul>
                    </td>
                    <td v-if="!Object.keys(selectedUser).length"></td>
                    <td v-if="!Object.keys(selectedUser).length"></td>
                    <td class="py-2 px-2" v-if="Object.keys(selectedUser).length" style="vertical-align:bottom;">
                        <button
                            class="bg-teal border-grey-light text-white pb-2 pt-2 pl-3 pr-3 rounded-lg float-right"
                            @click.prevent="updatePermissions()">Save
                        </button>
                    </td>
                    <td v-if="!Object.keys(selectedUser).length"></td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import Form from "../../utils/form";
import Multiselect from 'vue-multiselect';
export default {
    name: "dashboard-report",
    components: {Multiselect},
    data() {
        return {
            users: [],
            sales_behaviors: [],
            current_sales_behavior: null,
            selectedUser: [],
        };
    },

    created() {
        this.fetchData();
    },

    methods: {
        fetchData() {
            let self = this;

            if(!self.selectedUser) {

                axios.get(route("settings.dashboard-report")).then(({ data }) => {
                    self.users = data.data.users;
                    self.sales_behaviors = data.data.sales_behaviors;
                });
            }
            else {

                axios.get(route("settings.dashboard-report", {'id' : self.selectedUser.id})).then(({ data }) => {
                    self.users = data.data.users;
                    self.sales_behaviors = data.data.sales_behaviors;
                });
            }
        },

        updatePermissions(){
            axios.post(route('api.settings.sales-behavior-user.update'), {selectedUser: this.selectedUser})
                .then( (response) => {
                    Swal.fire({
                        title: 'Updated',
                        text: response.data.message,
                        type: 'success',
                        showCancelButton: false,
                        confirmButtonColor: '#01B1AF',
                        confirmButtonText: 'OK!',
                        closeOnConfirm: false,
                    });
                })
        }
    }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
    ul {
        list-style-type: none;
        display: table;
        margin: 0 auto;
        text-align: left;
    }
</style>
